var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOperateAc2Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4876 10.4047C17.4095 11.8515 16.914 13.2447 16.061 14.4159C15.208 15.587 14.034 16.4861 12.681 17.0043C11.3279 17.5225 9.85374 17.6377 8.43661 17.336C7.01948 17.0342 5.72009 16.3285 4.69552 15.304C3.67094 14.2795 2.96504 12.9802 2.66315 11.5631C2.36125 10.146 2.4763 8.6718 2.99436 7.31869C3.51243 5.96559 4.41135 4.79151 5.58245 3.93838C6.75354 3.08525 8.14669 2.5896 9.59347 2.51135C9.93097 2.49301 10.1076 2.89468 9.92847 3.18051C9.32921 4.13931 9.07261 5.27291 9.20055 6.39631C9.32848 7.51971 9.8334 8.56658 10.6329 9.36608C11.4324 10.1656 12.4793 10.6705 13.6027 10.7984C14.7261 10.9264 15.8597 10.6698 16.8185 10.0705C17.1051 9.89135 17.506 10.0672 17.4876 10.4047Z",
    stroke: "#00A63E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperateAc2Icon);
export default __webpack_public_path__ + "static/media/operate_ac_2_icon.fcf081c7afa84addf64a5d62e0f946ce.svg";
export { ForwardRef as ReactComponent };